import { render } from "./UiReadOnly.pug?vue&type=template&id=c5da5658&lang=pug"
import script from "./UiReadOnly.js?vue&type=script&lang=js"
export * from "./UiReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__